import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_link, {
      to: _ctx.receiptChargingLinkTo,
      class: "cursor-pointer"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseButton, {
          buttonClass: "main",
          disabled: !_ctx.chargeable,
          class: _normalizeClass(["my-4 w-4/5 justify-center", {
          'input-disabled': !_ctx.chargeable,
        }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["disabled", "class"])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}